import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFlowTestFlowTestInterpretation, deleteFlowTestInterpretation, getFlowTestFlowTestInterpretations, updateFlowTestInterpretation } from "../../api/flowTests/FlowTestInterpretation";
import { CreateFlowTestInterpretationRequest, UpdateFlowTestInterpretationRequest } from "../../types/model/flowTestInterpretation";

export const useFlowTestInterpretations = (flowTestIdStr?: string) => {
  const queryClient = useQueryClient();
  const flowTestId = Number(flowTestIdStr);

  const queryKey = ["flow-test", flowTestId, "interpretations"];

  const result = useQuery({
    queryKey,
    queryFn: () => getFlowTestFlowTestInterpretations(flowTestId),
    enabled: !!flowTestId,
  });

  const createMutation = useMutation({
    mutationFn: (values: CreateFlowTestInterpretationRequest) => createFlowTestFlowTestInterpretation(flowTestId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ interpretationId, values }: { interpretationId: number; values: UpdateFlowTestInterpretationRequest }) => updateFlowTestInterpretation(interpretationId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (interpretationId: number) => deleteFlowTestInterpretation(interpretationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    interpretationsData: result.data ?? [],
    isPending: result.isPending,
    isFetching: result.isFetching,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
    createInterpretation: createMutation.mutateAsync,
    updateInterpretation: updateMutation.mutateAsync,
    deleteInterpretation: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
